import React, { useState, useEffect } from 'react';
import { object, func, bool } from 'prop-types';

import { CloneObject } from '../../../utils/helpers';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useFormErrors } from '../../hooks/useFormErrors';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import { useEntidad } from '../../hooks/useEntidad';
import { DatePickerCustom, FormLabel, Modal, FormError } from '../../common';
import { isNull } from '../../../utils/validator';
import InputCustom from '../../common/InputCustom';
import {TIPS} from "../../../consts/tips";


const VariableGlobalModal = (props) => {

  const entityInit = {
    id: 0,
    idVariable: 0,
    valor: '',
    fechaDesde: null,
    fechaHasta: null
  };

  //hooks
  const [state, setState] = useState({
    entity: entityInit,
    showInfo: false
  });

  const [variable, setVariable] = useState({
    id: 0,
    codigo: '',
    descripcion: '',
    tipoDato: '',
    constante: false,
    predefinido: false,
    opcional: true,
    activo: true,
    global: true
  });

  const mount = () => {
    setState(prevState => {
      return {...prevState, entity: props.data.entity };
    });
    formSet({
      valor: props.data.entity.valor,
      fechaDesde: props.data.entity.fechaDesde,
      fechaHasta: props.data.entity.fechaHasta
    });
  }
  useEffect(mount, [props.data.entity]);

  const [, geRowEntidad, readyEntidad] = useEntidad({
    entidades: ['Variable'],
    onLoaded: (entidades, isSuccess, error) => {
      if (!isSuccess) {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: null
  });

  useEffect(() => {
    const row = geRowEntidad('Variable', state.entity.idVariable);
    if (row) {
      setVariable(row);
    }
  }, [state.entity.idVariable, readyEntidad]);

  const [ formValues, formHandle, , formSet ] = useForm({
    valor: '',
    fechaDesde: null,
    fechaHasta: null
  });

  const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

  //handles
  const handleClickAceptar = () => {
    if (!validate()) return;

    const aviso = getAvisoSinCampo();
    if (aviso) {
      ShowToastMessage(ALERT_TYPE.ALERT_WARNING, aviso);
      return;
    }

    let row = CloneObject(state.entity);
    row.valor = formValues.valor;
    row.fechaDesde = formValues.fechaDesde;
    row.fechaHasta = formValues.fechaHasta;

    props.onConfirm(row);
  };

  //funciones
  function getErrors() {

    const errors = {};

    if (!variable.constante) {
      if (!isNull(formValues.fechaDesde) && !isNull(formValues.fechaHasta) && formValues.fechaDesde > formValues.fechaHasta) errors.fechaHasta = 'No puede ser anterior a la fecha desde';
    }
    if (variable.tipoDato.length > 0 && formValues.valor.length <= 0) errors.valor = VALIDATION_MESSAGE.REQUIRED;

    return errors;
  }

  function getFormatErrors() {

    const errors = {};

    if (!variable.constante && esRangoSolapado()) errors.fechaDesde = 'El rango se superpone con otro';

    return errors;
  }

  function getAvisoSinCampo() {
    if (variable.tipoDato.length <= 0) return 'No se pudo resolver la variable';
    if (variable.constante && props.solapaOtroValor) return `La variable "${variable.descripcion}" es de tipo constante y tiene más de un registro cargado. Debe quedar uno solo.`;
    return null;
  }

  function esRangoSolapado() {
    const rango = props.rangoSolapado;
    return !isNull(rango)
        && sonLaMismaFecha(rango.fechaDesde, formValues.fechaDesde)
        && sonLaMismaFecha(rango.fechaHasta, formValues.fechaHasta);
  }

  function sonLaMismaFecha(una, otra) {
    if (isNull(una) || isNull(otra)) return isNull(una) && isNull(otra);
    return una.getTime() === otra.getTime();
  }

  return (
    <>

    <Modal
      size="lg"
      title={`Variable ${variable.codigo} (${variable.descripcion}) ${(state.entity.id > 0) ? "" : "(Nuevo valor)"}`}
      tipName={TIPS.NAME.MODALS.VARIABLE_GLOBAL_MODAL}
      onEscape={() => props.onDismiss()}
      body={(
            <div className="row">
                
              {!variable.constante &&
              <>
              <div className={`mb-3 ${variable.tipoDato === 'string' ? 'col-6' : 'col-4'}`}>
                  <label htmlFor="fechaDesde" className="form-label">Fecha desde</label>
                  <DatePickerCustom
                      name="fechaDesde"
                      placeholder=""
                      className={`form-control ${errorOf('fechaDesde') ? 'is-invalid' : ''}`}
                      value={ formValues.fechaDesde }
                      onChange={ formHandle }
                      disabled={props.disabled}
                  />
                  <FormError message={errorOf('fechaDesde')} />
              </div>

              <div className={`mb-3 ${variable.tipoDato === 'string' ? 'col-6' : 'col-4'}`}>
                  <label htmlFor="fechaHasta" className="form-label">Fecha hasta</label>
                  <DatePickerCustom
                      name="fechaHasta"
                      placeholder=""
                      className={`form-control ${errorOf('fechaHasta') ? 'is-invalid' : ''}`}
                      value={ formValues.fechaHasta }
                      onChange={ formHandle }
                      disabled={props.disabled}
                      minValue={formValues.fechaDesde}
                  />
                  <FormError message={errorOf('fechaHasta')} />
              </div>
              </>
              }

              {variable.tipoDato.length > 0 &&
              <div className={`mb-3 ${variable.tipoDato === 'string' ? 'col-12' : 'col-4'}`}>
                  <FormLabel htmlFor="valor" required>Valor</FormLabel>
                  {variable.tipoDato === 'string' ? (
                  <textarea
                      name="valor"
                      placeholder=""
                      className={`form-control ${errorOf('valor') ? 'is-invalid' : ''}`}
                      value={ formValues.valor }
                      onChange={ formHandle }
                      disabled={props.disabled}
                      rows="6"
                      maxLength={500}
                      style={{ resize: 'none' }}
                  />
                  ) : (
                  <InputCustom
                      name="valor"
                      type={ variable.tipoDato }
                      placeholder=""
                      className="form-control"
                      value={ formValues.valor }
                      onChange={ formHandle }
                      disabled={props.disabled}
                      serialize={true}
                      invalid={!!errorOf('valor')}
                  />
                  )}
                  <FormError message={errorOf('valor')} />
              </div>
              }

            </div>
      )}
      footer={!props.disabled ? (<>
              <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Cancelar</button>
              <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
      </>) : (
              <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
      )}
      footerClassName={props.disabled ? 'f-align' : ''}
    />

    </>
  );
}

VariableGlobalModal.propTypes = {
  disabled: bool,
  data: object.isRequired,
  rangoSolapado: object,
  solapaOtroValor: bool,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
};

VariableGlobalModal.defaultProps = {
  disabled: false,
  rangoSolapado: null,
  solapaOtroValor: false
};

export default VariableGlobalModal;